export enum dataType {
  'Calculated Field' = 'CAL',
  'Endpoint' = 'END',
  'Options' = 'OPT',
  'Date' = 'DAT',
  'Text' = 'CHR',
  'Integer' = 'INT',
  'Decimal' = 'DEC',
}

export interface tsStudyAttributeOption {
  AttrCodeSetID: number
  CodeDescription: string
  CodeValue: string
}

export interface tsStudyAttribute {
  StudyID: number
  PhaseID: string
  AttrID: number
  SeqNo: number
  AttrName: string
  AttrDatatype?: dataType
  AttrCodeSetID?: number
  EndpointText?: string
  Formula?: string
  options?: tsStudyAttributeOption[]
}
